import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import DatePicker           from 'react-datepicker';
import FieldError           from '../../Fragments/FieldError';
import moment               from 'moment';
import                      'react-datepicker/dist/react-datepicker.css';

let Quote = require('../../Managers/Quote.js');
let Validation = require('../../Managers/Validation.js');

class CalendarInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: true,
            activeValue: props.defaultValue ? props.defaultValue : null,
            displayTenancyMessage: this.props.displayTenancyMessage,
        };
    }

    componentDidMount() {
        if (!window.uorn(this.props.defaultValue)) {
            let defaultMoment = moment(this.props.defaultValue);
            this.setActiveValue(defaultMoment);
        }
    }

    setActiveValue(e) {
        let validation = Validation.validate(this.props.dataValidation, e, 'not_null')[0];
        this.setState(validation);

        if (validation.isValid) {
            this.setState(validation);
            if (moment(e).isAfter(moment().add(60, 'days'))) {
                this.props.callbackFunction();
            }
            else {
               this.setState({ displayTenancyMessage: true });
            }

        }

        // double val as i dont wanna upset the status quo...
        this.setState({
            activeValue: e,
            startDate: e
        }, () => {
            Quote.set(this.props.storageKey, moment(e).format('YYYY-MM-DD'), this.props.source);
            Quote.setAnswer(this.props.storageKey, moment(e).format('YYYY-MM-DD'));
            this.props.isValid(validation.isValid);
        });
    }

    getCurrentValue() {
        return this.state.activeValue;
    }

    handleValidation(e) {
        this.setActiveValue(e);
    }

    makeToday() {
        let today = moment();
        this.setActiveValue(today);
    }

    makeTomorrow() {
        let tomorrow = moment().add(1, 'day');
        this.setActiveValue(tomorrow);
    }

    render() {
        let currentDate = moment().format('YYYY-MM-DD');
        let tomorrowDate = moment().add(1, 'days').format('YYYY-MM-DD');
        let startDateSet = Quote.getCurrentAnswer(this.props.fieldName);
        return (
            <div>
                <div className="question-input">
                    <div className="datepicker">
                        <div className="desktop-date-picker-wrapper">
                            <div className="desktop-date-picker-element">
                                <DatePicker
                                    dateFormat="DD/MM/YYYY"
                                    minDate={this.props.minDate}
                                    maxDate={this.props.maxDate}
                                    className="form-control"
                                    id={this.props.fieldName}
                                    readOnly={true}
                                    onChange={this.setActiveValue.bind(this)}
                                    selected={this.state.startDate}
                                    defaultValue={this.state.startDate}
                                />
                            </div>
                            <div className="desktop-date-picker-element manual-date-setter">
                                <button
                                    className={startDateSet == currentDate ? 'btn btn-default enabled' : 'btn btn-default'}
                                    onClick={this.makeToday.bind(this)}
                                >
                                    Today
                                </button>
                            </div>
                            <div className="desktop-date-picker-element manual-date-setter">
                                <button
                                    onClick={this.makeTomorrow.bind(this)}
                                    className={startDateSet == tomorrowDate ? 'btn btn-default enabled' : 'btn btn-default'}
                                >
                                    Tomorrow
                                </button>
                            </div>
                        </div>
                    </div>

                    {this.state.hasError === true ?
                        <FieldError errors={this.state.errors} />
                    :null}
                </div>

                {this.state.displayTenancyMessage === true ?
                    <div className="supplemental input-supplemental">
                        <p><strong>Please note:</strong> applications are not prioritised on tenancy start date.</p>
                    </div>
                : null}
            </div>
        );
    }
}

CalendarInput.propTypes = {
    fieldName:              PropTypes.string.isRequired,
    storageKey:             PropTypes.string.isRequired,
    question:               PropTypes.string.isRequired,
    minDate:                PropTypes.object,
    maxDate:                PropTypes.object,
    callbackFunction:       PropTypes.func,
    dataValidation:         PropTypes.string,
    source:                 PropTypes.string,
    defaultValue:           PropTypes.string,
    isValid:                PropTypes.func,
    displayTenancyMessage:  PropTypes.bool,
};

CalendarInput.defaultProps = {
    minDate: moment(),
    maxDate: moment().add(6, 'months'),
};

export default CalendarInput;


// WEBPACK FOOTER //
// ./src/components/Fields/Dates/CalendarInput.js